import { assert, CheckedAddress } from '@sparkdotfi/common-universal'

import { getChainConfigEntry } from '@/config/chain'
import { TokenRepository } from '@/domain/token-repository/TokenRepository'
import { useTokenRepository } from '@/domain/token-repository/useTokenRepository'

export interface UseSwapTokenRepositoryParams {
  chainId: number
  account: CheckedAddress | undefined
}

export function useSwapTokenRepository({ chainId, account }: UseSwapTokenRepositoryParams): TokenRepository {
  const chainConfig = getChainConfigEntry(chainId)
  const swapConfig = chainConfig.swap
  assert(swapConfig, 'Swap config not available for this chain')

  return useTokenRepository({
    chainId,
    priceConfigs: swapConfig.priceConfigs,
    account,
  })
}
